import { Design } from 'blaze-ui/icons'
import { HoverActionOverlay, HoverActionOverlayProps } from 'components/HoverActionOverlay/HoverActionOverlay'
import { DESIGN_PATH } from 'paths'
import { generatePath, useHistory } from 'react-router-dom'

export const EditInDesignerOverlay = ({
  onAction,
  onClose,
  ...props
}: Omit<HoverActionOverlayProps, 'onAction' | 'buttonLabel'> & { almanacFileKey: string; onAction?: () => void }) => {
  const history = useHistory()

  const onEdit = () => {
    onClose?.()
    history.push(generatePath(DESIGN_PATH, { key: props.almanacFileKey }))
  }
  return (
    <HoverActionOverlay
      {...props}
      onAction={onAction || onEdit}
      buttonLabel="Edit Design"
      buttonProps={{
        frontIcon: Design,
        variant: 'secondary',
        ...props.buttonProps,
      }}
    >
      {props.children}
    </HoverActionOverlay>
  )
}
